import { render } from "./parameterDialog.component.vue?vue&type=template&id=23ed3f54&scoped=true&ts=true"
import script from "./parameterDialog.component.vue?vue&type=script&lang=ts"
export * from "./parameterDialog.component.vue?vue&type=script&lang=ts"

import "./parameterDialog.component.vue?vue&type=style&index=0&id=23ed3f54&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/WEAS/WEAS_CI/WEAS_FRONT/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23ed3f54"]])

export default __exports__